import { useEffect } from "react";

import * as executionBriefWorkOrderStore from "../../../../../pages/execution-brief/store/execution-brief-work-orders/execution-brief-work-orders.store";
import { IDuplicateExecutionBriefForm } from "../../../../../pages/execution-brief/types/duplicate-execution-brief-form.interface";

import { FormModal } from "../../../form-modal/form-modal.component";

import { DuplicateExecutionBriefForm } from "../duplicate-execution-brief-form/duplicate-execution-brief-form.component";
import { DuplicateExecutionBriefFormValidationRules } from "../duplicate-execution-brief-form/duplicate-execution-brief-form.validate";

import { DuplicateExecutionBriefModalProps } from "./duplicate-execution-brief-modal.props";

export const DuplicateExecutionBriefModal = (props: DuplicateExecutionBriefModalProps) => {
  const { isOpen } = props;

  useEffect(() => {
    if (isOpen) {
      executionBriefWorkOrderStore.fetchWorkOrders();
    }
  }, [isOpen]);

  const handleSubmit = (data: IDuplicateExecutionBriefForm) => {
    props.onSubmit({ ...data, id: props.id });
  };

  return (
    <FormModal
      defaultValues={{ name: "", workOrders: [] }}
      Form={DuplicateExecutionBriefForm}
      formValidation={DuplicateExecutionBriefFormValidationRules}
      isOpen={isOpen}
      modalErrors={props.errors}
      modalTitle="Duplicate Multi Channel Brief"
      onClose={props.onClose}
      submit={handleSubmit}
    />
  );
};
